// Announcements-API: prüft/setzt den "gesehen"-Status für eine Version.

import getToken from '../auth/getToken';

const API = () => process.env.REACT_APP_BACKEND_URL;
const SCOPE = () => [`${process.env.REACT_APP_CLIENT_ID}/.default`];

async function authHeaders(instance) {
  const token = await getToken(instance, SCOPE());
  if (!token) throw new Error('Keine gültige Authentifizierung');
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

export async function getAnnouncementSeen(instance, version) {
  const headers = await authHeaders(instance);
  const res = await fetch(
    `${API()}/api/announcements/seen?version=${encodeURIComponent(version)}`,
    { headers },
  );
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function markAnnouncementSeen(instance, version) {
  const headers = await authHeaders(instance);
  const res = await fetch(`${API()}/api/announcements/seen`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ version }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}
